import React, { useEffect, useState } from 'react';
import { useDispatch, getLocale, useSelector } from 'umi';
import UserGuideBox from '@/pages/home/components/UserGuideBox';
import { LANGUAGE_EN } from '@/pages/home/_config/config';
import { GUIDE_SYS_OPINION } from '@/pages/home/models/guide';

import { getWebEnv } from '@op/hooks/useGetPageSourceRule';
import { getGlobalPageSourceRule } from '@op/services';
import { ExcludeGuideSourceMap } from '@op/constants/page';
import useOpinionGuideData from './useOpinionGuideData';
import { OPINION_GUIDE_HIDE } from '.';

export default () => {
  // 新手引导相关
  const locale = getLocale();

  const { guideSys, userInfo, gameInfo } = useSelector((state: any) => {
    const {
      guide: { guideSys },
      home: { userInfo },
      opinionCommon: { gameInfo },
    } = state;
    return {
      guideSys,
      userInfo,
      gameInfo,
    };
  });
  const [guidePermissions, setGuidePermissions] = useState<string[]>([]);
  const [loading, setLoading] = useState(false);
  async function requestServerInfo() {
    if (gameInfo.edition_unified_id) {
      setLoading(true);
      const data = await getGlobalPageSourceRule({
        ...gameInfo,
        web_env: getWebEnv(),
      });
      const { not_permissions_page_source } = data;
      const currentPageSource = not_permissions_page_source || [];
      const guidePermissions: Array<string> = [];

      currentPageSource.map((item: { source: any }) => {
        const key = item.source;
        const value = ExcludeGuideSourceMap[key];
        if (value) guidePermissions.push(value);
      });
      setGuidePermissions(guidePermissions);
      setLoading(false);
    }
  }

  useEffect(() => {
    requestServerInfo();
  }, [gameInfo]);

  const dispatch = useDispatch();

  const setShowGuide = (show: boolean): void => {
    dispatch({
      type: 'guide/showOpinionGuideModule',
      payload: show,
    });
  };

  const { GuideData } = useOpinionGuideData({
    gameInfo,
    userInfo,
    guidePermissions,
  });

  return (
    guideSys === GUIDE_SYS_OPINION &&
    userInfo && (
      <UserGuideBox
        className={`dbo-guidebox ${locale === LANGUAGE_EN ? 'en' : 'cn'}`}
        data={GuideData}
        setShowGuide={setShowGuide}
        guideHideKey={OPINION_GUIDE_HIDE}
        loading={loading}
      />
    )
  );
};
